import { CircularProgress } from '@mui/material'
import './Loading.css'

const Loading = () => {
    return (
        <div className="Loading-root">
            <CircularProgress color="inherit" />
        </div>
    )
}

export default Loading
